import {
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverArrow,
  PopoverCloseButton,
  PopoverHeader,
  PopoverBody,
  List,
  ListItem,
  IconButton,
  Box,
  Flex,
  Text,
} from '@chakra-ui/react';
import { DateTime } from 'luxon';
import React from 'react';

import { DownloadButton } from './DownloadButton';
import { FiInfo } from 'react-icons/fi';

const OnlineStatusDot = ({ online }: { online: boolean }) => {
  return (
    <Box
      mr="4px"
      height="10px"
      width="10px"
      pr="8px"
      borderRadius="full"
      bgColor={online ? 'green.500' : 'gray.500'}
      display="inline-block"
    />
  );
};
export const PopoverDownloadButton = ({
  artifactDocumentId,
  creditFacilityId,
  items,
}: {
  artifactDocumentId: string;
  creditFacilityId: string;
  items: { id: string; timestamp: number }[];
}) => {
  const renderContent = () => (
    <List spacing={3} width="100%">
      {items
        .sort((a, b) => b.timestamp - a.timestamp)
        .map(({ id, timestamp }, index) => {
          const dateObject = new Date(timestamp);
          const formattedDate = DateTime.fromJSDate(dateObject)
            .setZone('America/New_York')
            .toLocaleString(DateTime.DATETIME_FULL);

          const version = items.length - index;
          const currentVersion = version === items.length;

          return (
            <ListItem key={id} display="block">
              <Flex align="center" wrap="nowrap">
                <Box flex="1">
                  <OnlineStatusDot online={currentVersion} />
                  Version {version} <br />
                  <Text fontSize="xs">{formattedDate}</Text>
                </Box>{' '}
                <DownloadButton
                  artifactDocumentId={artifactDocumentId}
                  creditFacilityId={creditFacilityId}
                  receivableDocumentationRawId={id}
                />
              </Flex>
            </ListItem>
          );
        })}
    </List>
  );

  return (
    <Popover placement="bottom" trigger="hover">
      <PopoverTrigger>
        <IconButton aria-label="Download options" icon={<FiInfo />} />
      </PopoverTrigger>
      <PopoverContent>
        <PopoverArrow />
        <PopoverCloseButton />
        <PopoverHeader>PDF Versions</PopoverHeader>
        <PopoverBody>{renderContent()}</PopoverBody>
      </PopoverContent>
    </Popover>
  );
};
